"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIntermediateFieldProposals = exports.isRequiredIntermediateFieldName = exports.getIntermediateCalcValidFieldTypes = exports.RequiredIntermediateFieldNames = void 0;
const lodash_1 = __importDefault(require("lodash"));
const RequiredIntermediateFields = {
    assignmentExclusion: ['string'],
    exposure: ['float'],
    originalOwnerSlug: ['string'],
    waiveAllEligibility: ['boolean'],
    waiveAllConcentration: ['boolean'],
    includeInConcentrationLimitDenominatorIfWaived: ['boolean'],
    normalizedDaysPastDue: [
        'integer',
        'optionalInteger',
        'float',
        'optionalFloat',
    ],
    normalizedDurationDays: [
        'integer',
        'optionalInteger',
        'float',
        'optionalFloat',
    ],
    normalizedisChargedOff: ['boolean', 'optionalBoolean'],
    normalizedisDelinquent: ['boolean', 'optionalBoolean'],
    normalizedOriginationDate: ['date', 'optionalDate'],
    normalizedInitialBalance: ['float', 'optionalFloat'],
};
exports.RequiredIntermediateFieldNames = Object.keys(RequiredIntermediateFields);
// given an intermediate calc field, return the valid field types
const getIntermediateCalcValidFieldTypes = (field) => {
    return RequiredIntermediateFields[field];
};
exports.getIntermediateCalcValidFieldTypes = getIntermediateCalcValidFieldTypes;
const isRequiredIntermediateFieldName = (test) => {
    return exports.RequiredIntermediateFieldNames.includes(test);
};
exports.isRequiredIntermediateFieldName = isRequiredIntermediateFieldName;
/**
 * Creates monaco-editor CompletionItem suggestions
 * @param usePrefix adds `requiredIntermediateFields` or `dynamicIntermediateFields` prefix onto suggestions for use outside of intermediate calc sections
 */
const createIntermediateFieldProposals = ({ intermediateCalcs, usePrefix = false, }) => {
    const [requiredItermediateCalcs, dynamicIntermediateCalcs,] = lodash_1.default.partition(intermediateCalcs, ({ field }) => (0, exports.isRequiredIntermediateFieldName)(field));
    return [
        ...lodash_1.default.map(requiredItermediateCalcs, ({ field, config: { type } }) => ({
            label: `${usePrefix ? 'requiredIntermediateFields.' : ''}${field}`,
            documentation: type,
            insertText: usePrefix ? `requiredIntermediateFields.${field}` : field,
        })),
        ...lodash_1.default.map(dynamicIntermediateCalcs, ({ field, config: { type } }) => ({
            label: `${usePrefix ? 'dynamicIntermediateFields.' : ''}${field}`,
            documentation: type,
            insertText: usePrefix ? `dynamicIntermediateFields.${field}` : field,
        })),
    ];
};
exports.createIntermediateFieldProposals = createIntermediateFieldProposals;
//# sourceMappingURL=RequiredIntermediateFields.js.map